module.exports = __webpack_public_path__ + "static/img/success.f39fbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/success.png
// module id = 6vyc
// module chunks = 1